// extracted by mini-css-extract-plugin
module.exports = {"root":"form_root__1r7WZ","outer":"form_outer__tyQO-","orderForm":"form_orderForm__3w6UE","back":"form_back__3Ojwc","label":"form_label__1SzDC"};